import {ethers} from 'ethers'

export const encodeParams = (dataTypes, data) => {
    const abiCoder = ethers.utils.defaultAbiCoder
    // 走不通这个
     console.log(abiCoder.encode(dataTypes, data).slice(2))
    return abiCoder.encode(dataTypes, data).slice(2)
  }